import { Dialog, DialogContent, DialogContentText, DialogTitle, Button, Divider } from '@mui/material';
import report from '../assets/ls_report.png';
import reportUI from '../assets/ls_report_ui.png';
import PropTypes from 'prop-types';

const ComingSoonPopup = ({ open, onClose }) => {

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="coming-soon-title"
      aria-describedby="coming-soon-description"
      PaperProps={{ sx: { minWidth: "50em", alignItems: "center" } }}
    >
      <DialogTitle id="coming-soon-title" sx={{textTransform: 'uppercase', fontSize: '40px', fontWeight: 700}}>
        Coming to your store
      </DialogTitle>
      <DialogContent>
        <Divider />
        <div className='coming-soon-popup'>
          <div className='body'>
            <div className='row'>
              <div className='column items-end'>
                <div className='row double-row w-11/12'>
                  <img className='w-full bg-yellow p-2.5' src={report} alt='ls-report' style={{height: 'fit-content'}}/>
                </div>
              </div>
              <div className='column'>
                <div className='row bg-white'>
                  <DialogContentText className='text'>
                    Safety Check is a tool that can help stores communicate the inspection results and recommendations to the customer in order to drive sales and customer satisfaction. 
                    It replaces the Service Checklist in Customer First. This new tool will be available to stores soon!
                  </DialogContentText>
                </div>
                <div className='row w-full'>
                  <img className='w-7/12 bg-yellow py-2.5 pr-2.5' src={reportUI} alt='ls-report-ui' />
                  <Button size='large' variant='contained' className='popup-button self-end' onClick={onClose}>
                    I got it!
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

ComingSoonPopup.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func
};

export default ComingSoonPopup;
